import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { SearchService } from '../../../shared/search/search.service';
import { ComponentID, ActionType, PermissionHelper } from '../../../shared/helpers/permissionshelper';
import { Logging } from '../../../logging';
import { routerNgProbeToken } from '@angular/router/src/router_module';

declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  accountprofile : any;
  inputform:  FormGroup;
  pcinputform:  FormGroup;
  docinputform:  FormGroup;
  showBErrors :Boolean = false;
  loading: boolean;
  hasBError: boolean;
  errorMessage: any;
  successMessage : any;

  showPErrors :Boolean = false;
  hasPError: boolean;

  showDErrors :Boolean = false;
  hasDError: boolean;

  currPage: number = 1;
  totalItems: number;
  itemsPerPage: number;
  search_term: any = '';
  searchTerm$ = new Subject<string>();
  savedwallets:any[];
  editid: number  = 0;
  editedwallet : any = null;

  documenttypes : any[];
  uploadCrop: any;
  croppedimage : any = null;
  saveddocslst : any[] ;
  saveddocsimages : any[];

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private searchService: SearchService,private componentid : ComponentID ,
    private actiontype: ActionType,private permhelper:PermissionHelper, private route: ActivatedRoute) { }


    activeRoute: string = "profile";
  ngOnInit() {

    this.inputform = new FormGroup({
      businessname: new FormControl('',Validators.required),
      address: new FormControl(false,Validators.required),
      businessregno: new FormControl(false,Validators.required),
      email: new FormControl(false,[Validators.required,Validators.email]),
      lineofbusiness: new FormControl(false,Validators.required),
      location: new FormControl(false,Validators.required),
      telephone: new FormControl(false,[Validators.required,Validators.pattern("[0-9]*"),
      Validators.minLength(10),
      Validators.maxLength(12)])
    });

    this.pcinputform = new FormGroup({
      contactperson: new FormControl(false,Validators.required),
      contactdesignation: new FormControl(false,Validators.required),
      contactemail: new FormControl(false,[Validators.required,Validators.email]),
      contacttelephone: new FormControl(false,[Validators.required,
        Validators.pattern("[0-9]*"),
        Validators.minLength(10),
        Validators.maxLength(12)])
    });

    this.docinputform = new FormGroup({
      documenttypeid: new FormControl(false,Validators.required),
      documentnumber: new FormControl(false,Validators.required),
      issueddate: new FormControl(false,[Validators.required]),
      expirydate: new FormControl(),
      upload:new FormControl()
    });

   // $(".default-select2").select2();
   var self = this;
   self.uploadCrop = $('#upload-demo').croppie({
      enableExif: true,
      viewport: {
          width: 200,
          height: 200,
          type: 'square'
      },
      boundary: {
          width: 300,
          height: 300
      },
    showZoomer: true,
    enableResize: true,
    enableOrientation: true,
    mouseWheelZoom: 'ctrl'
  });

  $('#upload').on('change', function ()
  {
    self.readFile(this);
  });



  $('.upload-result').on('click', function (ev) {
    self.uploadCrop.croppie('result', {
      type: 'canvas',
      size: 'viewport'
    }).then(function (resp) {
    // console.log(resp);
     self.croppedimage = resp;
     $('#croppedhref').attr('href',resp);
     $('#imgcropped').attr('src',resp);

    });
  });
    //Fetch the available wallet grand groups
    this.api.get('/users/'+ this.auth.getAccountID()+'/accountprofile')
    .subscribe(
      res_data => {
      Logging.log(res_data.data);

       this.accountprofile = res_data.data;
      // Logging.log(this.accountprofile.businessname);
       this.inputform.controls.businessname.setValue(this.accountprofile.businessname);
       this.inputform.controls.address.setValue(this.accountprofile.address);
       this.inputform.controls.businessregno.setValue(this.accountprofile.businessregno);
       this.inputform.controls.email.setValue(this.accountprofile.email);
       this.inputform.controls.lineofbusiness.setValue(this.accountprofile.lineofbusiness);
       this.inputform.controls.location.setValue(this.accountprofile.location);
       this.inputform.controls.telephone.setValue(this.accountprofile.telephone);


       this.pcinputform.controls.contactperson.setValue(this.accountprofile.contactperson);
       this.pcinputform.controls.contactdesignation.setValue(this.accountprofile.contactdesignation);
       this.pcinputform.controls.contactemail.setValue(this.accountprofile.contactemail);
       this.pcinputform.controls.contacttelephone.setValue(this.accountprofile.contacttelephone);

      }, error_message => {
       //  this.loading = false;
       //  this.hasError = true;
      this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
      }
    );


     //Fetch the available document types
     this.api.get('/options/documenttypes')
     .subscribe(
       res_data => {
      //  Logging.log(res_data.data);

       //Collect the document types if the request was successful and there was data retured.
       if(res_data.status == "SUCCESS" && res_data.data.length > 0 ){
        this.documenttypes = res_data.data;
        Logging.log(res_data.data);

        //Pull saved documents
           this.getDocs(0);

       }


       }, error_message => {
        //  this.loading = false;
        //  this.hasError = true;
       this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
       }
     );


    this.searchService.search(this.searchTerm$)
      .subscribe(results => {
         Logging.log('search triggered');
        this.search_term = results;
        this.getDocs(0)
      });

  }


  getDocImgae(docid:number)
  {
    const img = this.saveddocsimages.filter(i => i.documentid == docid);
    if(img && img.length > 0)
    {
      return img[0].image;
    }
    return "assets/img/no-image-icon-12.jpg";
  }

fetchDocImage(docid: number)
{
  //Fetch the available document types
  this.api.get('/accounts/'+ this.auth.getAccountID() + '/documents/'+docid+'/image')
  .subscribe(
    res_data => {
   //  Logging.log(res_data.data);

    //Collect the document types if the request was successful and there was data retured.
    if(res_data.status == "SUCCESS" && res_data.data.length > 0 ){
     //Logging.log(res_data.data);
     this.saveddocsimages.push(res_data.data[0]);
    }
    }, error_message => {
     //  this.loading = false;
     //  this.hasError = true;
    //this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
    }
  );
}

getDocTypeName(id:number)
{
  const doc = this.documenttypes.filter(d =>d.id==id);
  if(doc && doc.length > 0)
  {
    return doc[0].name;
  }
  return id;
}

  getDocs(page:number){

    this.loading = true;
    window.scrollTo(0, 0);
    //Fetch all users
    this.api.get('/accounts/'+ this.auth.getAccountID() + '/documents' + '?sort=createddate,desc&search='+this.search_term+'&page=' + page)
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.saveddocslst = res_data.data.content;
      this.totalItems = res_data.data.totalElements;
      this.itemsPerPage = res_data.data.size;
      this.currPage = res_data.data.number;
      this.loading = false;
      this.saveddocsimages = [];
      this.saveddocslst.forEach(element => {
        this.fetchDocImage(element.id);
      });



      }, error_message => {
        this.loading = false;
       //  this.hasError = true;
       //  this.errorMessage = error_message;
      }
    );
  }


  readFile(input :any)
  {
    var self = this;
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      $("#ex1").modal({
        escapeClose: false,
        clickClose: false,
        showClose: false
      });

      reader.onload = function (e) {
        const img: any = e;
      $('.upload-demo').addClass('ready');
      self.uploadCrop.croppie('bind', {
         url: img.target.result
        }).then(function(){
         // console.log('jQuery bind complete');
          //console.log(e.target.result);
        });
      }

     reader.readAsDataURL(input.files[0]);
  }
  else {
    Logging.log("Sorry - you're browser doesn't support the FileReader API");
}

  }


  onBSubmit(){
    //Set loading to true to show loader
    this.loading = true;
    this.hasBError = false;

    if(this.inputform.valid){
      Logging.log(this.inputform.value);
      const regfields = this.inputform.value;

      const requestpayload = {
        accountid: this.auth.getAccountID(),
        businessname: regfields.businessname,
        address : regfields.address,
        businessregno : regfields.businessregno,
        email : regfields.email,
        lineofbusiness : regfields.lineofbusiness,
        location : regfields.location,
        telephone : regfields.telephone,
        //just to make sure we maintain what is currently there
        contactperson:this.accountprofile.contactperson,
        contactdesignation:this.accountprofile.contactdesignation,
        contactemail:this.accountprofile.contactemail,
        contacttelephone: this.accountprofile.contacttelephone,
        createdby : this.accountprofile.createdby,
        createddate : this.accountprofile.createddate
      };

      //Save details the sub user

      this.api.put('/users/' + this.auth.getAccountID() + '/accountprofile', requestpayload)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.accountprofile = res_data.data;
        this.helpers.flashSuccess('Details saved successfully');
        this.loading = false;
        this.hasBError = false;

        }, error_message => {
          this.loading = false;
          this.hasBError = true;
          this.errorMessage = error_message;
        }
      );


    }
    else
    {
      this.loading = false;
      this.hasBError = false;

      this.showBErrors = true;
      Logging.log('Has Errors', this.inputform.value);
    }
  }




  onPCSubmit ()
  {
    this.loading = true;
    this.hasPError = false;

    if(this.pcinputform.valid){

      Logging.log(this.pcinputform.value);
      const regfields = this.pcinputform.value;

      const requestpayload = {
        accountid: this.auth.getAccountID(),
        contactperson:regfields.contactperson,
        contactdesignation:regfields.contactdesignation,
        contactemail:regfields.contactemail,
        contacttelephone: regfields.contacttelephone,
        //just to make sure we maintain what is currently there
        businessname: this.accountprofile.businessname,
        address : this.accountprofile.address,
        businessregno : this.accountprofile.businessregno,
        email : this.accountprofile.email,
        lineofbusiness : this.accountprofile.lineofbusiness,
        location : this.accountprofile.location,
        telephone : this.accountprofile.telephone,
        createdby : this.accountprofile.createdby,
        createddate : this.accountprofile.createddate
      };

      //Save details the sub user
      this.api.put('/users/' + this.auth.getAccountID() + '/accountprofile', requestpayload)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.accountprofile = res_data.data;
        this.helpers.flashSuccess('Details saved successfully');
        this.loading = false;
        this.hasPError = false;

        }, error_message => {
          this.loading = false;
          this.hasPError = true;
          this.errorMessage = error_message;
        }
      );

    }
    else{
      this.loading = false;
      this.hasPError = false;

      this.showPErrors = true;
      Logging.log('Has Errors', this.pcinputform.value);
    }

  }


  onDocSubmit ()
  {
    this.loading = true;
    this.hasPError = false;


    if(this.croppedimage == null)
    {
      this.loading = false;
      this.helpers.flashDanger('Image of document is required');
      return;
    }

    if(this.docinputform.valid  )
    {
      Logging.log('Valid', this.docinputform.value);
      const regfields = this.docinputform.value;

      const requestpayload = { details: {
        accountid: this.auth.getAccountID(),
        name:regfields.documentnumber,
        documenttypeid:regfields.documenttypeid,
        documentnumber:regfields.documentnumber,
        issueddate: regfields.issueddate,
        expirydate: (regfields.expirydate != "") ? regfields.expirydate : null
      },
      image: {
        image : this.croppedimage
      }
      };

      //Save details of the document
      this.api.post('/accounts/' + this.auth.getAccountID() + '/documents/addwithdoc', requestpayload)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);

        this.saveddocslst.push(res_data.data[0].details);
        this.saveddocsimages.push(res_data.data[0].image);

            $('#imgcropped').attr('src',"assets/img/no-image-icon-12.jpg");
            $('#croppedhref').attr('href',"assets/img/no-image-icon-12.jpg");

            this.docinputform.controls.documenttypeid.setValue('');
            this.docinputform.controls.documentnumber.setValue('');
            this.docinputform.controls.issueddate.setValue('');
            this.docinputform.controls.expirydate.setValue('');
            this.docinputform.controls.upload.setValue('');
            this.helpers.flashSuccess('Details saved successfully');

            this.loading = false;
            this.hasPError = false;

      }, error_message => {
        this.loading = false;
        this.hasPError = true;
        this.errorMessage = error_message;
        this.helpers.flashDanger(error_message);
        }
      );

    }
    else{
      this.loading = false;
      this.hasDError = false;
      this.showDErrors = true;
      Logging.log('Has Errors', this.docinputform.value);
    }

  }


  clearErrors()
  {
    this.hasBError = false;
    this.errorMessage ="";
    this.loading= false;
  }


  clearPErrors()
  {
    this.hasPError = false;
    this.errorMessage ="";
    this.loading= false;
  }

}



// WEBPACK FOOTER //
// ./src/app/client/account/profile/profile.component.ts